import { render } from "./BCollapse.vue?vue&type=template&id=0ad36a07&ts=true"
import script from "./BCollapse.vue?vue&type=script&lang=ts"
export * from "./BCollapse.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__